<script setup>

import LandingPageNavBar from '@/components/navigation/LandingPageNavigationBar.vue';
import Footer from '@/components/landing/Footer.vue';
import {
  ref, provide, onMounted, onUnmounted,
} from 'vue';

const activeSection = ref('');
provide('activeSection', activeSection);

let observer;

onMounted(() => {
  const sections = document.querySelectorAll('section[id]');
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activeSection.value = entry.target.id;
        }
      });
    },
    {
      threshold: 0.3,
      rootMargin: '0px 0px -30% 0px',
    },
  );

  sections.forEach((section) => observer.observe(section));
});

onUnmounted(() => {
  if (observer) observer.disconnect();
});
</script>

<template>
  <LandingPageNavBar />
  <RouterView />

  <Footer />
</template>

<style scoped>

</style>
